/* Rquiere de mixin.js */

var transport = {
	data () {
		return {
			listTransports: [],
			methods: {
				transportGet: 'transports',
			},
			paginationTransports: [],
			searchTransports: '',
            searchingTransport: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllTransports(page = 1) {
			this.searchingTransport = true
			let parameters = '?search=' + this.searchTransports + '&page=' + page
            this.$emit('showLockScreen', 'Obteniendo lista de Transportes . . .')
			this.axiosActionIS(this.getApiBackend + this.methods.transportGet + parameters, 'GET', 'getAllTransportsResult')
        },
        getColorTransport(id) {
            let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            return (index > -1) ? this.listTransports[index].color : ''
        },
        getNameTransport(id) {
            let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            return (index > -1) ? this.listTransports[index].name : ''
        },
		resultAxiosLocalTranspor(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		getAllTransportsResult(response) {
			this.searchingTransport = false
			this.$emit('hideLockScreen')
			if(response.data.success == true) {
				this.listTransports = response.data.data
				this.paginationTransports = response.data.paginate
			}
			this.getAllTransportsResultLocal(response)
		},
		getAllTransportsResultLocal(response) {
			console.log('getAllTransportsResultLocal no desarrollado', response)
		},
		searchIdTransportsByStr(str) {
			let index = this.listTransports.map((el) => el.name.trim().toUpperCase()).indexOf(str.trim().toUpperCase())
			if(index == -1)
				return index
			return this.listTransports[index].id
		}
	},
};

export default transport;